module.exports = __webpack_public_path__ + "media/animation_llf0urb0.3c7fd256.mp4";